import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import {
  normalizeBankAccountManageResponse,
  normalizeBankAccountEntityResponse,
  normalizeBankAccountSummaryResponse,
} from 'lib/normalization';
import { BankAccount } from 'types/dto';
import { SortDirection } from 'types/sort';
import { RequestStatus } from 'types/transport';
import { AccountAction } from './actions';

const entitiesReducer = createReducer<Record<string, BankAccount>>({})
  .handleType(AccountAction.Clear, () => ({}))
  .handleType(AccountAction.ListResponse, (state, action) => {
    const [entities] = normalizeBankAccountManageResponse(action.payload);
    return entities;
  })
  .handleType(AccountAction.Response, (state, action) => {
    const [entities] = normalizeBankAccountEntityResponse(action.payload);
    return entities;
  })
  .handleType(AccountAction.SummaryResponse, (state, action) => {
    const [entities] = normalizeBankAccountSummaryResponse(action.payload);
    return entities;
  });

const idsReducer = createReducer<Array<string>>([])
  .handleType(AccountAction.Clear, () => [])
  .handleType(AccountAction.ListResponse, (state, action) => {
    const [, ids] = normalizeBankAccountManageResponse(action.payload);
    return ids;
  })
  .handleType(AccountAction.Response, (state, action) => {
    const [, ids] = normalizeBankAccountEntityResponse(action.payload);
    return ids;
  })
  .handleType(AccountAction.SummaryResponse, (state, action) => {
    const [, ids] = normalizeBankAccountSummaryResponse(action.payload);
    return ids;
  });

const sortDirReducer = createReducer<Nullable<SortDirection>>(null).handleType(
  AccountAction.Sort,
  (state, action) => action.payload.direction ?? null,
);

const sortKeyReducer = createReducer<Nullable<string>>(null).handleType(
  AccountAction.Sort,
  (state, action) => action.payload.key ?? null,
);

const statusReducer = createReducer<RequestStatus>(RequestStatus.None)
  .handleType(AccountAction.Clear, () => RequestStatus.None)
  .handleType(AccountAction.Create, () => RequestStatus.Creating)
  .handleType(AccountAction.Created, () => RequestStatus.Success)
  .handleType(AccountAction.Error, () => RequestStatus.Error)
  .handleType(AccountAction.ListRequest, () => RequestStatus.Reading)
  .handleType(AccountAction.ListResponse, () => RequestStatus.Success)
  .handleType(AccountAction.Request, () => RequestStatus.Reading)
  .handleType(AccountAction.Response, () => RequestStatus.Success)
  .handleType(AccountAction.SummaryRequest, () => RequestStatus.Reading)
  .handleType(AccountAction.SummaryResponse, () => RequestStatus.Success)
  .handleType(AccountAction.Update, () => RequestStatus.Updating)
  .handleType(AccountAction.Updated, () => RequestStatus.Success);

export default combineReducers({
  entities: entitiesReducer,
  ids: idsReducer,
  sortDir: sortDirReducer,
  sortKey: sortKeyReducer,
  status: statusReducer,
});
